'use client';

import {
  Link,
  LocaleSwitcher,
  useHrefOptions,
  useTranslations,
} from '@northladder/i18n';
import { TCompanyId, useAuthStore } from '@northladder/services';

import { CompanyLogo } from '../../brand';

/**
 * -----------------------------------------------------------------------------
 * Renders the top navigation part of the app. (App Logo alone in this case.)
 */
export function AppHeader() {
  const t = useTranslations('Manifest');
  const { homePath } = useHrefOptions();
  const companyId = useAuthStore()?.activityLog?.companyId as TCompanyId;

  return (
    <header className="py-4 md:py-8">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <nav className="relative z-50 flex justify-between">
          <div className="flex items-center md:gap-x-12">
            <Link aria-label="Home" href={`/${homePath}`}>
              <CompanyLogo
                className="
                  focus-visible:outline-primary-600 focus:outline-hidden duration-800
                  h-4 transition-all ease-in-out
                  focus-visible:outline-2 focus-visible:outline-offset-1 sm:h-6
                "
                logoId={companyId}
              />
              <span
                className="
                  font-display sm:text-md dark:text-primary-50 text-gray0 mx-auto
                  max-w-4xl py-2 font-light tracking-tight
                "
              >
                {t('appName')}
              </span>
            </Link>
          </div>

          <LocaleSwitcher
            className="relative !left-0 !right-0 !block !rounded-full"
            isInline={false}
          />
        </nav>
      </div>
    </header>
  );
}
